import SetPassword from './SetPassword.vue';
import ExpiredToken from './ExpiredToken.vue';
import store from '@/store';
import authentication from '@/authentication';

const routes = [
  {
    path: '/set-password/:id/:code',
    name: 'SetPassword',
    component: SetPassword,
    meta: {
      isPublic: true,
    },
    async beforeEnter(to, from, next) {
      if (store['vue-persist-patch-delay']) {
        await store['vue-persist-patch-delay'];
      }

      const actions = [];
      if (to.params.id) {
        actions.push(
          store.dispatch(
            `${authentication.store.namespace}/setPasswordResetId`,
            to.params.id
          )
        );
      }
      if (to.params.code) {
        actions.push(
          store.dispatch(
            `${authentication.store.namespace}/setPasswordResetCode`,
            to.params.code
          )
        );
      }

      Promise.all(actions).then(next).catch(next);
    },
  },
  {
    path: '/expired-token',
    name: 'ExpiredToken',
    component: ExpiredToken,
    meta: {
      isPublic: true,
    },
  },
];

export default routes;
